import React from 'react';
import { useLocation } from 'react-router-dom';

import DefaultLayout from '../../_layouts/default';

import List from './List';
import Record from './Record';
import DataLoad from './DataLoad';

const PolicyGroups: React.FC = () => {
  const { pathname } = useLocation();

  const getComponent = (): React.ReactNode => {
    if (pathname.indexOf('/configurations/policygroups/record') !== -1) {
      return <Record />;
    }

    if (pathname === '/configurations/policygroups/dataload') {
      return <DataLoad />;
    }

    return <List />;
  };

  return <DefaultLayout>{getComponent()}</DefaultLayout>;
};

export default PolicyGroups;
